import React from "react";
import { TextInput, required, NumberInput, useLoading } from "react-admin";
import { Grid } from "@mui/material";
import CustomDateInput from "server/components/Fields/CustomDateInput";

const SaveForm = () => {
  const loading = useLoading();

  const greaterThanZero = value => {
    if (value === undefined || value === null) return;
    if (value <= 0) return "Стойността трябва да е по-голяма от 0";
  };
  return (
    <Grid
      container
      spacing={2}
    >
      <Grid
        item
        xs={12}
        md={4}
      >
        <TextInput
          label="Име на български език"
          source="nameBg"
          validate={required()}
          readOnly={loading}
        />
      </Grid>

      <Grid
        item
        xs={12}
        md={4}
      >
        <TextInput
          label="Име на английски език"
          source="nameEn"
          validate={required()}
          readOnly={loading}
        />
      </Grid>

      <Grid
        item
        xs={12}
        md={4}
      >
        <TextInput
          label="Местоположение"
          source="location"
          validate={required()}
          readOnly={loading}
        />
      </Grid>

      <Grid
        item
        xs={12}
        md={3}
        sx={{ mb: 3 }}
      >
        <CustomDateInput
          label="Начало на регистрация"
          source="registrationStart"
          noTime
          required={true}
          readOnly={loading}
        />
      </Grid>

      <Grid
        item
        xs={12}
        md={3}
        sx={{ mb: 3 }}
      >
        <CustomDateInput
          label="Край на регистрация"
          source="registrationEnd"
          noTime
          required={true}
          readOnly={loading}
        />
      </Grid>

      <Grid
        item
        xs={12}
        md={3}
        sx={{ mb: 3 }}
      >
        <CustomDateInput
          label="Начална дата"
          source="startDate"
          noTime
          required={true}
          readOnly={loading}
        />
      </Grid>

      <Grid
        item
        xs={12}
        md={3}
        sx={{ mb: 3 }}
      >
        <CustomDateInput
          label="Крайна дата"
          source="endDate"
          noTime
          required={true}
          readOnly={loading}
        />
      </Grid>
      <Grid
        item
        xs={12}
        md={2}
      >
        <NumberInput
          label="Капацитет"
          source="capacity"
          validate={[required(), greaterThanZero]}
          readOnly={loading}
        />
      </Grid>

      <Grid
        item
        xs={12}
        md={2}
      >
        <NumberInput
          label="Резерва"
          source="reserve"
          validate={[required(), greaterThanZero]}
          readOnly={loading}
        />
      </Grid>

      <Grid
        item
        xs={12}
        md={8}
      >
        <TextInput
          label="Описание"
          source="description"
          validate={required()}
          readOnly={loading}
        />
      </Grid>
    </Grid>
  );
};

export default SaveForm;
